module.exports = __webpack_public_path__ + "img/logo.f26fef52.svg";